import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	sizeLabel: {
		id: 'company-hub-common.config.styles.size.label',
		defaultMessage: 'Size',
		description: 'Label for size field in styles section',
	},
	sizeSmall: {
		id: 'company-hub-common.config.styles.size.small',
		defaultMessage: 'Small',
		description: 'Small size option of size field in extensionconfig panel to change the size of the targeted extension to small',
	},
	sizeLarge: {
		id: 'company-hub-common.config.styles.size.large',
		defaultMessage: 'Large',
		description: 'Large size option of size field in extension config panel to change the size of the targeted extension to large',
	},
});
